import React, { useEffect, useState } from "react";
import { TL } from "../i18n";
import client from "../lib/api";
import { Link } from "react-router-dom";
import { Wrench, X } from "lucide-react";

// Advance/active scheduled-maintenance banner. Public status endpoint; shows on the dashboard.
export const MaintenanceBanner = () => {
  const [st, setSt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    client.get("/maintenance/status").then((r) => {
      const d = r.data;
      if (d && d.enabled && (d.scheduled || d.active)) {
        setSt(d);
        setDismissed(localStorage.getItem("maint_banner_dismissed") === d.end_utc);
      }
    }).catch(() => {});
  }, []);

  if (!st || dismissed) return null;
  const fmt = (iso) => { try { return new Date(iso).toLocaleString(undefined, { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit", hour12: false }); } catch { return iso; } };
  const dismiss = () => { localStorage.setItem("maint_banner_dismissed", st.end_utc); setDismissed(true); };

  return (
    <div data-testid="dashboard-maintenance-banner"
      className="flex items-center gap-3 rounded-xl border border-[#F1C21B]/50 bg-[#F1C21B]/10 px-4 py-3 text-sm">
      <Wrench size={18} className="flex-shrink-0 text-[#9e7b00] dark:text-[#F1C21B]" />
      <span className="flex-1">
        {st.active
          ? <><b>{TL("Maintenance in progress.")}</b> Some features may be unavailable until {fmt(st.end_utc)} (your local time).</>
          : <><b>{TL("Scheduled maintenance.")}</b> The system will be down from {fmt(st.start_utc)} to {fmt(st.end_utc)} (your local time).</>}
        {" "}<Link to="/maintenance" className="underline" data-testid="maintenance-banner-details">{TL("Details & other languages →")}</Link>
      </span>
      <button onClick={dismiss} data-testid="maintenance-banner-dismiss" className="opacity-60 hover:opacity-100"><X size={16} /></button>
    </div>
  );
};
